"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasAllPermissions = exports.hasOnePermission = exports.hasPermission = exports.hadFeatureTrial = exports.hasFeatureTrial = exports.getValidTrialForFacility = exports.facilitiesHaveOneFeature = exports.hasAllFeatures = exports.hasOneFeature = exports.facilityHasFeature = exports.hasFeature = exports.isActiveUser = exports.isAnyStaff = exports.isEnterprise = exports.isFamily = exports.isResident = exports.isSupport = exports.isStaff = exports.isAdminUserType = void 0;
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var admin_1 = require("../constants/admin");
var user_status_1 = __importDefault(require("../constants/user.status"));
var user_types_1 = __importDefault(require("../constants/user.types"));
var isAdminUserType = function (userType) {
    return Object.values(admin_1.ADMIN_USER_TYPE).some(function (type) { return type.value === userType; });
};
exports.isAdminUserType = isAdminUserType;
var isStaff = function (user) {
    return (user === null || user === void 0 ? void 0 : user.type) === user_types_1.default.staff;
};
exports.isStaff = isStaff;
var isSupport = function (user) {
    return (user === null || user === void 0 ? void 0 : user.type) === user_types_1.default.support;
};
exports.isSupport = isSupport;
var isResident = function (user) {
    return (user === null || user === void 0 ? void 0 : user.type) === user_types_1.default.resident;
};
exports.isResident = isResident;
var isFamily = function (user) {
    return (user === null || user === void 0 ? void 0 : user.type) === user_types_1.default.family;
};
exports.isFamily = isFamily;
var isEnterprise = function (user) {
    return (user === null || user === void 0 ? void 0 : user.type) === user_types_1.default.enterprise;
};
exports.isEnterprise = isEnterprise;
var isAnyStaff = function (user) {
    return (0, exports.isStaff)(user) || (0, exports.isEnterprise)(user) || (0, exports.isAdminUserType)(user === null || user === void 0 ? void 0 : user.type);
};
exports.isAnyStaff = isAnyStaff;
var isActiveUser = function (user) {
    return (user === null || user === void 0 ? void 0 : user.status) === user_status_1.default.active;
};
exports.isActiveUser = isActiveUser;
var hasFeature = function (user, feature) {
    return !!user &&
        (0, lodash_1.some)(user.facilities, function (facility) {
            return facility.features.filter(function (featureKey) { return featureKey === feature; }).length;
        });
};
exports.hasFeature = hasFeature;
var facilityHasFeature = function (facility, feature) { return facility.features.some(function (featureKey) { return featureKey === feature; }); };
exports.facilityHasFeature = facilityHasFeature;
var hasOneFeature = function (user, features) {
    return !!user &&
        (0, lodash_1.some)(user.facilities, function (fac) { return fac.features.filter(function (feat) { return features === null || features === void 0 ? void 0 : features.includes(feat); }).length; });
};
exports.hasOneFeature = hasOneFeature;
var hasAllFeatures = function (user, features) {
    return !!user &&
        (0, lodash_1.some)(user.facilities, function (fac) {
            return fac.features.filter(function (feat) { return features === null || features === void 0 ? void 0 : features.includes(feat); }).length ===
                (features === null || features === void 0 ? void 0 : features.length);
        });
};
exports.hasAllFeatures = hasAllFeatures;
var facilitiesHaveOneFeature = function (facilities, features) {
    return (0, lodash_1.some)(facilities, function (fac) { return fac.features.filter(function (feat) { return features === null || features === void 0 ? void 0 : features.includes(feat); }).length; });
};
exports.facilitiesHaveOneFeature = facilitiesHaveOneFeature;
var getValidTrialForFacility = function (feature, daysValid) { return function (facility) {
    return (0, lodash_1.find)(facility.featureTrials, function (_a) {
        var featureKey = _a.featureKey, startedAt = _a.startedAt;
        return (0, lodash_1.toNumber)(featureKey) === feature &&
            (0, moment_1.default)(startedAt)
                .add(daysValid, 'days')
                .isSameOrAfter((0, moment_1.default)(), 'day');
    });
}; };
exports.getValidTrialForFacility = getValidTrialForFacility;
var hasFeatureTrial = function (facilities, feature, daysValid) {
    return (0, lodash_1.some)(facilities, function (facility) { return !!(0, exports.getValidTrialForFacility)(feature, daysValid)(facility); });
};
exports.hasFeatureTrial = hasFeatureTrial;
var hadFeatureTrial = function (facilities, feature, daysValid) {
    return (0, lodash_1.some)(facilities, function (facility) {
        var _a, _b;
        return !!((_b = (_a = facility.featureTrials) === null || _a === void 0 ? void 0 : _a.filter(function (_a) {
            var featureKey = _a.featureKey, startedAt = _a.startedAt;
            return (0, lodash_1.toNumber)(featureKey) === feature &&
                (0, moment_1.default)(new Date(startedAt))
                    .add(daysValid, 'days')
                    .isBefore((0, moment_1.default)(), 'day');
        })) === null || _b === void 0 ? void 0 : _b.length);
    });
};
exports.hadFeatureTrial = hadFeatureTrial;
var hasPermission = function (user, permission, includeOther) {
    if (includeOther === void 0) { includeOther = true; }
    return (includeOther && ((0, exports.isAdminUserType)(user === null || user === void 0 ? void 0 : user.type) || (0, exports.isEnterprise)(user))) ||
        ((0, exports.isStaff)(user) && (0, lodash_1.includes)((user === null || user === void 0 ? void 0 : user.permissions) || [], permission));
};
exports.hasPermission = hasPermission;
var hasOnePermission = function (user, permissions, includeOther) {
    if (includeOther === void 0) { includeOther = true; }
    if (!permissions) {
        return false;
    }
    var normalizedPermissions = Array.isArray(permissions)
        ? permissions
        : [permissions];
    return ((includeOther && ((0, exports.isAdminUserType)(user === null || user === void 0 ? void 0 : user.type) || (0, exports.isEnterprise)(user))) ||
        ((0, exports.isStaff)(user) &&
            !!(0, lodash_1.intersection)((user === null || user === void 0 ? void 0 : user.permissions) || [], normalizedPermissions).length));
};
exports.hasOnePermission = hasOnePermission;
var hasAllPermissions = function (user, permissions, includeOther) {
    if (includeOther === void 0) { includeOther = true; }
    return (includeOther && ((0, exports.isAdminUserType)(user === null || user === void 0 ? void 0 : user.type) || (0, exports.isEnterprise)(user))) ||
        ((0, exports.isStaff)(user) &&
            !!((0, lodash_1.intersection)((user === null || user === void 0 ? void 0 : user.permissions) || [], permissions).length ===
                (permissions === null || permissions === void 0 ? void 0 : permissions.length)));
};
exports.hasAllPermissions = hasAllPermissions;
